export default __webpack_public_path__ + "static/media/money.d0f2cc1d.png";